<template>
  <div>
    <div class="text-h6">{{ appCompany.company_name }}</div>
    <!-- <StatusChip :value="appCompany.state" class="mb-3" /> -->
    <div class="d-flex" :class="[openReason ? 'mb-1' : 'mb-6', state ? 'justify-space-around' : '']">
      <div v-if="state" class="d-flex flex-column">
        <span class="text-caption text--secondary">статус компании:</span>
        <StatusChip small :value="model.state" />
      </div>
      <div
        v-if="(extra && extra.tasks_statuses)"
        class="d-flex flex-column"
        :style="!state ? 'margin-right: 20px' : ''"
      >
        <span class="text-caption text--secondary">проверка документов:</span>
        <StatusChip :value="extra.tasks_statuses.documents" />
      </div>

      <div v-if="(extra && extra.tasks_statuses)" class="d-flex flex-column">
        <span class="text-caption text--secondary">проверка паспорта:</span>
        <StatusChip :value="extra.tasks_statuses.persons" />
      </div>
    </div>
    <div>
      <v-chip class="mb-6" v-if="openReason" small outlined color="#F9C1BD" text-color="#A61D1D">{{
        model.decline.openReason
      }}</v-chip>
    </div>
    <v-row>
      <v-col cols="12" class="pa-2">
        <v-card width="100%" class="pa-4 company__details d-flex align-center justify-space-between" elevation="0">
          <div>
            <div class="mb-1">{{ appCompany.person_fullname }}</div>
            <div class="text--secondary">{{ getCompanyType(appCompany.company_type) }}</div>
          </div>
          <div v-if="appCompany && appCompany.lastUpd" class="d-flex align-center">
            <v-chip class="font-weight-medium ag-status-chip px-2 mr-2" small color="#D4F296" text-color="#5E8C00">
              Обновлено
            </v-chip>
            <div class="mr-1 text-body-2 text--secondary">{{ new Date(appCompany.lastUpd).toLocaleDateString() }}</div>
            <div class="font font--label-light text--secondary">
              {{ new Date(appCompany.lastUpd).toLocaleTimeString() }}
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" class="d-flex pa-2">
        <v-card class="pa-4 company__details d-flex justify-center flex-column" elevation="0" width="100%">
          <div class="d-flex mb-2">
            <div class="text--secondary mr-2">ИНН:</div>
            {{ appCompany.inn }}
          </div>
          <div class="d-flex">
            <div class="text--secondary mr-2">ОГРН:</div>
            {{ appCompany.ogrn }}
          </div>
        </v-card>
      </v-col>

      <v-col cols="6" class="d-flex pa-2">
        <v-card class="pa-4 company__details justify-center flex-column" elevation="0" width="100%">
          <div class="text-body-2 text--secondary mb-1">Контакты</div>
          <div v-if="appCompany && appCompany.person_phone" :class="appCompany.person_email ? 'mb-2' : ''">
            <v-icon class="mr-4">mdi-phone</v-icon>
            <a :href="`tel:${appCompany.person_phone}`" class="font">{{ formatPhone(appCompany.person_phone) }}</a>
          </div>
          <div v-if="appCompany && appCompany.person_email">
            <v-icon class="mr-4">mdi-email-outline</v-icon>
            <a :href="`mailto:${appCompany.person_email}`" class="font">
              {{ appCompany.person_email }}
            </a>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="8" v-if="partner" class="d-flex pa-2">
        <v-card class="pa-4 company__details d-flex justify-center flex-column" elevation="0" width="100%">
          <div class="text-body-2 text--secondary mb-1">Источник</div>
          <div class="mb-2"><span class="text--secondary">ФИО:</span> {{ partner.client_name }}</div>
          <div class="mb-2"><span class="text--secondary">Тип:</span> {{ getPartnerType(partner.type) }}</div>
          <div><span class="text--secondary">ИНН:</span> {{ partner.inn }}</div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import StatusChip from "@/components/common/StatusChip";
import { formatPhone } from "@/utils/helpers";

export default {
  name: "AppCompanyTab",

  props: {
    companyData: {
      type: Object,
    },
  },
  components: {
    StatusChip,
  },
  data() {
    return {
      company_type: {
        UL: "Общество с ограниченной ответственностью",
        IP: "Индивидуальный предприниматель",
      },
      partner_type: {
        partner: "Партнер",
      },
    };
  },
  methods: {
    formatPhone(value) {
      return formatPhone(value);
    },
    getCompanyType(type) {
      return this.company_type[type];
    },
    getPartnerType(type) {
      return this.partner_type[type];
    },
  },
  computed: {
    ...mapState("app", ["appCompany"]),
    ...mapGetters("app", ["extra", "model"]),
    partner() {
      return this.extra?.partner;
    },
    openReason() {
      if (!this.model?.decline?.openReason) return false;
      return true;
    },
    state() {
      if (this.model && this.model?.state) return true;
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.company__details {
  background-color: #f5f5f6;
}
</style>
